import providers from "@/lib/api";
import config from "@/config";

export const userPublicDataFieldsWithStoryInfo = (): string => {
  let r = providers.UserPublicDataProvider.getFragment("UserPublicData");
  if (config.featureStories) r += "... on UserPublicData { hasStories firstNotViewedStoryId }";
  return r;
};

export const messageThreadFields = (): string => {
  let r = providers.UserPublicDataProvider.getFragment("MessageThread");
  if (config.featureStories)
    r += "... on MessageThread { users {... on UserPublicData { hasStories firstNotViewedStoryId }}}";
  return r;
};
